var ModalHandler = {
	stack: [],
	$wrapper: $("#modal-wrapper"),

	// Agregar nuevo modal
	add(caller, stack = false) {

		// Si el nuevo reemplaza al existente, hay que borrar al existente
		if (!stack) {
			this.hideCurrent();
		}
		// Si el nuevo permite stackear, los existentes deben pasar a segundo plano
		else {
			this.$wrapper.find('.modal').addClass('modal-off');
		}

		// Agregar el nuevo modal
		this.$wrapper.append(caller.$modal);
		// Agregar al stack
		this.stack.push(caller);
	},

	remove(caller) {

		const index = this.stack.indexOf(caller);
		if (index !== -1) {
			this.stack.splice(index, 1);
		}
		if (this.stack.length == 0) {
			$('body').removeClassRegex(/^modal-/);
		}
		else {
			// reagrego la clase modal a mano, al cerrar el modal, si hay otro abierto, puede llegar a sacarle la clase al body
			$('body').addClass('modal-open');

			if (this.$wrapper.find('.modal').not('.modal-off').length == 0)
				this.$wrapper.find('.modal-off').last().removeClass('modal-off');

		}
	},

	hideCurrent() {
		const current = this.current();
		if (current) current.hide();
	},

	current: function () {
		if (this.stack.length == 0)
			return undefined;

		return this.stack[this.stack.length - 1];
	},
}

